import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Button,
  Typography,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import "./ProcessTable.css";
import Dashboard from "../../dashboard/Dashboard";

import { useNavigate } from "react-router-dom";
import { ProcessTable } from "./ProcessTable";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useDispatch, useSelector } from "react-redux";
import {
  createJob,
  creatTool,
  editJob,
  getAllTools,
} from "../../../actions/job";
import { ArrowBack } from "../../../common/BackArrow";
import { handleSelection } from "../../../utils/HandleBreadcrumb";
import CustomBreadcrumb from "../../../common/CustomBreadcrumb";
import MyModal from "../../../utils/Modal";
import { formatDecimalMinutesToMinutesSeconds } from "../../../utils/timeHelper";
import CustomToolModal from "../../../common/CustomToolModal";

function CreateJob() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const { tools: allTools = [] } = useSelector((state) => state.tool);
  const requiredFieldsByProcess = {
    Milling: [
      "process",
      "description",
      "machineName",
      "toolingUsed",
      "toolingSize",
      "width",
      "length",
      "feed",
      "dc",
      "mr",
      "requiredDimension",
      "estimatedCT",
    ],
    Boring: [
      "process",
      "description",
      "machineName",
      "toolingUsed",
      "toolingSize",
      "width", // Added Width
      "length", // Added Length
      "dc",
      "mr",
      "requiredDimension",
      "estimatedCT",
    ],
    Drilling: [
      "process",
      "description",
      "machineName",
      "toolingUsed",
      "dia",
      "rpm",
      "feed",
      "length",
      "noh",
      "requiredDimension",
      "estimatedCT",
    ],
    Tapping: [
      "process",
      "description",
      "machineName",
      "toolingUsed",
      "dia",
      "rpm",
      "feed",
      "length",
      "noh",
      "requiredDimension",
      "estimatedCT",
    ],
  };
  const [containers, setContainers] = useState(() => {
    const savedContainers = JSON.parse(localStorage.getItem("containers"));
    return (
      savedContainers || [
        {
          processName: "",
          setting: null, // Add any initial values you need
          processTableData: [],
        },
      ]
    );
  });

  const [formData, setFormData] = useState(() => {
    const savedFormData = JSON.parse(localStorage.getItem("formData"));
    return (
      savedFormData || {
        // jobId: null, // Add jobId to the initial state
        soWo: "",
        prodOrderNo: "",
        woDate: new Date().toISOString().split("T")[0],
        jobName: "",
        poNo: "",
        estimatedtotalCT: 0,
        actualtotalCT: 0,
        dragNo: "",
        processTable: containers,
      }
    );
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  // Add these states for custom tool modal
  const [toolModalOpen, setToolModalOpen] = useState(false);
  const [customToolName, setCustomToolName] = useState("");
  const [currentToolContext, setCurrentToolContext] = useState({
    containerIndex: null,
    rowIndex: null,
    processType: null,
  });
  const [errors, setErrors] = useState({
    soWo: false,

    jobName: false,
    poNo: false,
    estimatedtotalCT: false,

    dragNo: false,
  });
  const [processTableErrors, setProcessTableErrors] = useState(() => {
    const savedContainers = JSON.parse(localStorage.getItem("containers")) || [
      {
        processName: "",
        setting: null,
        processTableData: [],
      },
    ];

    return savedContainers.map((container) => {
      return container.processTableData.map(() => ({
        process: false,
        description: false,
        machineName: false,
        toolingUsed: false,
        toolingSize: false,
        width: false,
        length: false,
        dc: false,
        mr: false,
        noh: false,
        requiredDimension: false,
        estimatedCT: false,
      }));
    });
  });

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      localStorage.removeItem("formData");
      localStorage.removeItem("containers");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  // Fetch all tools on component mount
  useEffect(() => {
    dispatch(getAllTools());
  }, [dispatch]);

  // Function to get filtered tools by parentType
  const getFilteredTools = (parentType) => {
    if (!parentType || !allTools || allTools.length === 0) return [];
    return allTools.filter((tool) => tool.parentType === parentType);
  };

  // Modify your ProcessTable component or create a custom ToolSelect component
  const ToolSelect = ({
    containerIndex,
    rowIndex,
    processName,
    value,
    onChange,
  }) => {
    const filteredTools = getFilteredTools(processName);

    return (
      <FormControl fullWidth size="small">
        <InputLabel>Tooling Used</InputLabel>
        <Select
          value={value || ""}
          label="Tooling Used"
          onChange={(e) =>
            onChange(e, rowIndex, "toolingUsed", containerIndex, processName)
          }
          error={processTableErrors[containerIndex]?.[rowIndex]?.toolingUsed}
        >
          <MenuItem value="">
            <em>Select Tool</em>
          </MenuItem>
          {filteredTools.map((tool) => (
            <MenuItem key={tool._id} value={tool.toolingName}>
              {tool.toolingName}
            </MenuItem>
          ))}
          {/* Add custom tool option */}
          <MenuItem value="custom">
            <em>+ Add Custom Tool</em>
          </MenuItem>
        </Select>
      </FormControl>
    );
  };

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      processTable: containers,
    }));
  }, [containers]);

  useEffect(() => {
    localStorage.setItem("formData", JSON.stringify(formData));
    localStorage.setItem("containers", JSON.stringify(containers));
  }, [formData, containers]);

  useEffect(() => {
    const totalEstimatedCT = calculateTotalEstimatedCT(containers);

    setFormData((prevData) => ({
      ...prevData,
      processTable: containers,
      estimatedtotalCT: totalEstimatedCT,
    }));

    // Clear the estimatedtotalCT error when it's calculated
    if (errors.estimatedtotalCT && totalEstimatedCT > 0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        estimatedtotalCT: false,
      }));
    }
  }, [containers]); // This will run whenever containers array changes

  // Add a function to format the total estimated CT for display
  const formatTotalEstimatedCT = (decimalMinutes) => {
    return formatDecimalMinutesToMinutesSeconds(decimalMinutes);
  };

  const formatTotalEstimatedCTWithBreakdown = (containersData) => {
    let processTime = 0;
    let settingTime = 0;

    containersData.forEach((container) => {
      settingTime += parseFloat(container.setting) || 0;
      container.processTableData.forEach((row) => {
        processTime += parseFloat(row.estimatedCT) || 0;
      });
    });

    const total = processTime + settingTime;

    return {
      total: formatDecimalMinutesToMinutesSeconds(total),
      processTime: formatDecimalMinutesToMinutesSeconds(processTime),
      settingTime: formatDecimalMinutesToMinutesSeconds(settingTime),
      rawTotal: total,
    };
  };

  // Usage in your component:
  const totalCTBreakdown = formatTotalEstimatedCTWithBreakdown(containers);

  const handleValidation = (event, rowIndex) => {
    const enteredValue = event.target.value;
    console.log("validation", enteredValue);
    if (!/^[0-9]*$/.test(enteredValue)) {
      // If the entered value is not a number, update the error state

      setProcessTableErrors((prevErrors) => ({
        ...prevErrors,
        [rowIndex]: {
          ...prevErrors[rowIndex],
          toolingSize: "Only numbers are allowed",
        },
      }));
    } else {
      // If the entered value is a number, clear the error state
      setProcessTableErrors((prevErrors) => ({
        ...prevErrors,
        [rowIndex]: {
          ...prevErrors[rowIndex],
          toolingSize: "",
        },
      }));
    }
  };

  const handleOpenModal = (message) => {
    setModalMessage(message);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalMessage("");
  };

  // Add these functions for custom tool handling
  const handleOpenToolModal = (containerIndex, rowIndex, processType) => {
    setCurrentToolContext({
      containerIndex,
      rowIndex,
      processType,
    });
    setCustomToolName("");
    setToolModalOpen(true);
  };

  const handleCloseToolModal = () => {
    setToolModalOpen(false);
    setCustomToolName("");
    setCurrentToolContext({
      containerIndex: null,
      rowIndex: null,
      processType: null,
    });
  };

  const handleSaveCustomTool = async (customToolName) => {
    if (!customToolName.trim()) {
      alert("Please enter a tool name");
      return;
    }

    const { containerIndex, rowIndex, processType } = currentToolContext;

    try {
      // Save custom tool to backend
      const payload = {
        toolingName: customToolName,
        parentType: processType,
      };
      const createdTool = await dispatch(creatTool(payload));
      console.log("createdTool", createdTool);

      if (createdTool.type === "tools/createTools/fulfilled") {
        // Update the toolingUsed field in the current row
        handleTextFieldChange(
          { target: { value: customToolName } },
          rowIndex,
          "toolingUsed",
          containerIndex,
          processType
        );

        handleCloseToolModal();
      } else {
        alert("Failed to save custom tool");
      }
    } catch (error) {
      console.error("Error saving custom tool:", error);
      alert("Error saving custom tool");
    }
  };

  // const handlePrint = () => {
  //   // Use the window.print() method to trigger the browser's print dialog
  //   window.print();
  // };
  const handleSubmit = async (e, formDataToSubmit) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    // Update the formData with the current containers state
    // Use the passed form data or construct from current state
    const dataToSubmit = formDataToSubmit || {
      ...formData,
      processTable: containers,
    };
    const totalEstimatedCT = containers?.reduce((total, container) => {
      const containerEstimatedCT = container.processTableData.reduce(
        (containerTotal, data) => {
          if (!isNaN(data?.actualCT)) {
            return containerTotal + data?.actualCT;
          }
          return containerTotal;
        },
        0
      );
      return total + containerEstimatedCT;
    }, 0);

    // Update the formData state with the new totalEstimatedCT value
    setFormData((prevData) => ({
      ...prevData,
      actualtotalCT: parseFloat(totalEstimatedCT).toFixed(2),
    }));

    // Rest of your code

    const requiredFields = [
      "soWo",

      "jobName",
      "poNo",
      "estimatedtotalCT",
      "dragNo",
    ];

    const ProcessrequiredFields = [
      "process",
      "description",
      "machineName",
      "toolingUsed",
      // "dc",
      // "length",
      // "width",
      // "feed",
    ];
    const newErrors = {};

    requiredFields.forEach((field) => {
      if (!dataToSubmit[field]) {
        newErrors[field] = true;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      //   setProcessTableErrors(processTableErrors);
      return;
    }

    const newProcessTableErrors = containers.map((container) => {
      return container.processTableData.map((data) => {
        const rowErrors = {};

        ProcessrequiredFields.forEach((field) => {
          if (!data[field]) {
            rowErrors[field] = true;
          }
        });

        return rowErrors;
      });
    });
    setProcessTableErrors(newProcessTableErrors);

    // Check for processTableErrors
    const hasProcessTableErrors = newProcessTableErrors.some(
      (containerErrors) =>
        containerErrors.some((rowErrors) =>
          Object.values(rowErrors).some((error) => error)
        )
    );
    console.log("errror", newProcessTableErrors);
    if (hasProcessTableErrors) {
      handleOpenModal("Fill all Process Table Data.");
      return;
    }
    const hasEmptyRow = containers.some(
      (item) => item.processTableData.length === 0
    );

    if (hasEmptyRow) {
      handleOpenModal("At least one row in the process table is required.");
      return;
    }

    if (containers.length === 0) {
      handleOpenModal("At least one row in the process table is required.");
      return;
    }
    containers.map((item) => {
      if (item.processTableData.length === 0) {
        handleOpenModal("At least one row in the process table is required.");
        return;
      }
    });
    console.log("formData", formData);

    try {
      if (!dataToSubmit.jobId) {
        // Create a new job
        const createdJob = await dispatch(createJob(dataToSubmit));

        if (createdJob?.payload && createdJob?.payload?._id) {
          let newJobId = createdJob?.payload?._id;
          setFormData((prevData) => ({
            ...prevData,
            jobId: newJobId,
          }));
          await dispatch(editJob({ id: newJobId, formData: dataToSubmit }));

          // Show success message
          handleOpenModal("Job has been successfully saved!");
        } else {
          handleOpenModal("Job creation failed. Please try again.");
        }
      } else {
        // Update existing job
        const result = await dispatch(
          editJob({ id: dataToSubmit.jobId, formData: dataToSubmit })
        );
        // Show success message
        if (result?.payload?.success === false) {
          handleOpenModal("Update failed. Please try again.");
        } else {
          handleOpenModal("Job updated successfully!");
          // Optional: Clear form or navigate away
          // navigate(-1);
        }
      }

      // Clear localStorage after saving job
      localStorage.removeItem("formData");
      localStorage.removeItem("containers");
    } catch (error) {
      console.error("Error saving job:", error);
      handleOpenModal(
        "An error occurred while saving the job. Please try again."
      );
    }

    // Clear localStorage after saving job
    localStorage.removeItem("formData");
    localStorage.removeItem("containers");
  };
  const calculateTotalEstimatedCT = (containersData) => {
    const total = containersData.reduce((total, container) => {
      // Add setting time for this container (convert to number, default to 0)
      const settingTime = parseFloat(container.setting) || 0;

      const containerTotal = container.processTableData.reduce(
        (containerSum, row) => {
          // Parse the value to handle both numbers and strings
          const estimatedCT = parseFloat(row.estimatedCT) || 0;
          return containerSum + estimatedCT;
        },
        settingTime // Start with setting time for this container
      );
      return total + containerTotal;
    }, 0);

    // Return formatted to 2 decimal places
    return parseFloat(total.toFixed(2));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: false,
      }));
    }
  };

  // Maintain an array of containers
  const calculateCT = (updatedData) => {
    if (!updatedData.idleCode) {
      console.log(updatedData.startTime);
      const startDate = new Date(updatedData.startDate);
      const endDate = new Date(updatedData.endDate);
      const startTime = new Date(`1970-01-01T${updatedData.startTime}`);
      const endTime = new Date(`1970-01-01T${updatedData.endTime}`);
      const start =
        startDate.getTime() +
        startTime.getTime() -
        startDate.getTimezoneOffset() * 60 * 1000;
      const end =
        endDate.getTime() +
        endTime.getTime() -
        endDate.getTimezoneOffset() * 60 * 1000;
      const diff = (end - start) / (1000 * 60);
      console.log("diff", diff); // difference in hours
      return diff;
      // updatedData.estimatedCT = diff;
    } else {
      const startDate = new Date(updatedData.startDate);
      const endDate = new Date(updatedData.endDate);
      const startTime = new Date(`1970-01-01T${updatedData.startTime}`);
      const endTime = new Date(`1970-01-01T${updatedData.endTime}`);
      const start =
        startDate.getTime() +
        startTime.getTime() -
        startDate.getTimezoneOffset() * 60 * 1000;
      const end =
        endDate.getTime() +
        endTime.getTime() -
        endDate.getTimezoneOffset() * 60 * 1000;
      const diff1 = (end - start) / (1000 * 60);
      const startDate1 = new Date(updatedData.startDate1);
      const endDate1 = new Date(updatedData.endDate1);
      const startTime1 = new Date(`1970-01-01T${updatedData.startTime1}`);
      const endTime1 = new Date(`1970-01-01T${updatedData.endTime1}`);
      const start1 =
        startDate1.getTime() +
        startTime1.getTime() -
        startDate1.getTimezoneOffset() * 60 * 1000;
      const end1 =
        endDate1.getTime() +
        endTime1.getTime() -
        endDate1.getTimezoneOffset() * 60 * 1000;
      const diff2 = (end1 - start1) / (1000 * 60); // difference in hours
      const diff = diff1 + diff2;
      console.log(diff);

      return parseFloat(diff).toFixed(2);
    }
  };

  const handleTextFieldChange = (
    event,
    rowIndex,
    fieldName,
    containerIndex,
    processName
  ) => {
    const value = event.target.value;
    const isBlurEvent = event.type === "blur";
    // Handle custom tool selection
    if (fieldName === "toolingUsed" && value === "custom") {
      handleOpenToolModal(containerIndex, rowIndex, processName);
      return;
    }
    setContainers((prevContainers) => {
      const updatedContainers = [...prevContainers];
      const containerToUpdate = { ...updatedContainers[containerIndex] };

      containerToUpdate.processTableData =
        containerToUpdate.processTableData.map((data, index) => {
          if (index === rowIndex) {
            const updatedRow = { ...data, [fieldName]: value };
            const requiredFields = requiredFieldsByProcess[processName] || [];
            const allFieldsFilled = requiredFields.every(
              (field) =>
                updatedRow[field] && updatedRow[field].toString().trim() !== ""
            );

            if (isBlurEvent && allFieldsFilled) {
              const newFormData = {
                ...formData,
                processTable: updatedContainers,
              };
              handleSubmit(null, newFormData);
            }

            // Process-specific calculations
            if (processName === "Milling") {
              if (fieldName === "toolingUsed") {
                // If a tool is selected, you might want to auto-populate other fields
                const selectedTool = allTools.find(
                  (tool) =>
                    tool.toolingName === value &&
                    tool.parentType === processName
                );
                if (selectedTool) {
                  updatedRow.toolingUsed = selectedTool;
                }
              }
              if (
                fieldName === "toolingSize" ||
                fieldName === "dia" ||
                fieldName === "width" ||
                fieldName === "length" ||
                fieldName === "feed" ||
                fieldName === "nop" ||
                fieldName === "fpp" ||
                fieldName === "mr" ||
                fieldName === "dc"
              ) {
                updatedRow.dia = parseFloat(
                  (updatedRow.toolingSize * 0.9).toFixed(2)
                );
                updatedRow.nop = parseFloat(
                  (updatedRow.width / updatedRow.dia).toFixed(2)
                );
                updatedRow.fpp = parseFloat(
                  (updatedRow.length / updatedRow.feed).toFixed(2)
                );
                updatedRow.estimatedCT =
                  updatedRow.nop *
                  updatedRow.fpp *
                  (updatedRow.mr / updatedRow.dc) *
                  1.25;

                if (fieldName === "estimatedCT") {
                  updatedRow.estimatedCT = value;
                }
                if (
                  updatedRow.estimatedCT !== undefined &&
                  !isNaN(updatedRow.estimatedCT)
                ) {
                  updatedRow.estimatedHrs = updatedRow.estimatedCT / 60;
                }
              }
            } else if (processName === "Boring") {
              if (
                fieldName === "mr" ||
                fieldName === "dc" ||
                fieldName === "width" ||
                fieldName === "length" ||
                fieldName === "nop" ||
                fieldName === "fpp"
              ) {
                // Calculate Number of Passes (NOP) = MR / DC
                updatedRow.nop = parseFloat(
                  updatedRow.mr / updatedRow.dc
                ).toFixed(2);

                // Calculate Feed per Pass (FPP) = Length / (Width × 0.1)
                // Assuming Width affects feed rate - adjust the multiplier as needed
                updatedRow.fpp = parseFloat(
                  (updatedRow.length / (updatedRow.width * 0.1)).toFixed(2)
                );

                // Boring Cycle Time Formula: NOP × FPP × 1.25 (safety factor)
                updatedRow.estimatedCT = updatedRow.nop * updatedRow.fpp * 1.25;

                if (
                  updatedRow.estimatedCT !== undefined &&
                  !isNaN(updatedRow.estimatedCT)
                ) {
                  updatedRow.estimatedHrs = updatedRow.estimatedCT / 60;
                }
              }
            } else if (processName === "Drilling") {
              // NEW DRILLING CALCULATION WITH TIME-PER-HOLE BASED ON DIAMETER
              if (fieldName === "dia" || fieldName === "noh") {
                // Get time per hole based on diameter range
                let timePerHole = 0;
                const dia = parseFloat(updatedRow.dia) || 0;

                if (dia >= 1 && dia <= 14) {
                  timePerHole = 3; // 3 min/hole for diameter 3-14
                } else if (dia >= 16 && dia <= 21) {
                  timePerHole = 8; // 8 min/hole for diameter 16-21
                } else if (dia >= 22 && dia <= 60) {
                  timePerHole = 12; // 12 min/hole for diameter 22-42
                }

                // Calculate estimated CT: time per hole × number of holes
                updatedRow.estimatedCT =
                  timePerHole * (parseFloat(updatedRow.noh) || 0);

                if (
                  updatedRow.estimatedCT !== undefined &&
                  !isNaN(updatedRow.estimatedCT)
                ) {
                  updatedRow.estimatedHrs = updatedRow.estimatedCT / 60;
                }
              }
            } else if (processName === "Tapping") {
              // NEW TAPPING CALCULATION WITH TIME-PER-HOLE BASED ON DIAMETER
              if (fieldName === "dia" || fieldName === "noh") {
                // Get time per hole based on diameter range
                let timePerHole = 0;
                const dia = parseFloat(updatedRow.dia) || 0;

                if (dia >= 1 && dia <= 14) {
                  timePerHole = 2; // 2 min/hole for diameter 3-14
                } else if (dia >= 16 && dia <= 21) {
                  timePerHole = 3; // 3 min/hole for diameter 16-21
                } else if (dia >= 22 && dia <= 60) {
                  timePerHole = 4; // 4 min/hole for diameter 22-42
                }

                // Calculate estimated CT: time per hole × number of holes
                updatedRow.estimatedCT =
                  timePerHole * (parseFloat(updatedRow.noh) || 0);

                if (
                  updatedRow.estimatedCT !== undefined &&
                  !isNaN(updatedRow.estimatedCT)
                ) {
                  updatedRow.estimatedHrs = updatedRow.estimatedCT / 60;
                }
              }
            }

            // Calculate estimatedCT if relevant fields are updated
            if (
              fieldName === "startTime" ||
              fieldName === "endTime" ||
              fieldName === "startTime1" ||
              fieldName === "endTime1" ||
              fieldName === "startDate1" ||
              fieldName === "endDate1" ||
              fieldName === "idleCode"
            ) {
              const diff = calculateCT(updatedRow);
              updatedRow.estimatedCT = diff;
            }

            // Recalculate estimatedHrs if estimatedCT has been updated
            if (
              updatedRow.estimatedCT !== undefined &&
              !isNaN(updatedRow.estimatedCT)
            ) {
              updatedRow.estimatedHrs = updatedRow.estimatedCT / 60;
            }

            return updatedRow;
          }
          return data;
        });

      updatedContainers[containerIndex] = containerToUpdate;
      const totalEstimatedCT = calculateTotalEstimatedCT(updatedContainers);

      setFormData((prevFormData) => ({
        ...prevFormData,
        estimatedtotalCT: totalEstimatedCT,
      }));
      return updatedContainers;
    });
  };

  const handleAddRow = (containerIndex) => {
    setContainers((prevContainers) => {
      const updatedContainers = [...prevContainers];
      const containerToUpdate = { ...updatedContainers[containerIndex] };

      // Create a new row with initial data
      const newRow = {
        process: "",
        description: "",
        machineName: "",
        toolingUsed: "",
        toolingSize: "",
        width: "",
        length: "",
        dc: "",
        mr: "",
        noh: "",
        requiredDimension: "",
        estimatedCT: 0,
        estimatedHrs: 0,
        nop: 0,
        fpp: 0,
      };

      // Create a new array with the updated processTableData
      const updatedProcessTableData = [
        ...containerToUpdate.processTableData,
        newRow,
      ];

      // Update the container's processTableData with the new array
      containerToUpdate.processTableData = updatedProcessTableData;

      // Update the containers state with the modified container
      updatedContainers[containerIndex] = containerToUpdate;

      return updatedContainers;
    });

    // Update processTableErrors when adding a new row
    setProcessTableErrors((prevErrors) => {
      const newErrors = [...prevErrors];
      if (!newErrors[containerIndex]) {
        newErrors[containerIndex] = [];
      }

      newErrors[containerIndex] = [
        ...newErrors[containerIndex],
        {
          process: false,
          description: false,
          machineName: false,
          toolingUsed: false,
          toolingSize: false,
          width: false,
          length: false,
          dc: false,
          mr: false,
          noh: false,
          requiredDimension: false,
          estimatedCT: false,
        },
      ];

      return newErrors;
    });
  };

  const handleDeleteRow = (containerIndex, rowIndex) => {
    // Clone the containers array to avoid modifying the state directly
    const updatedContainers = [...containers];

    // Remove the row from the process table data for the specified container
    updatedContainers[containerIndex].processTableData.splice(rowIndex, 1);

    // Update the state with the modified containers array
    setContainers(updatedContainers);
  };

  const addContainer = () => {
    // Create a new container with initial data
    const newContainer = {
      dropdownValue: "",
      processTableData: [],
    };

    // Update the containers state with the new container
    setContainers((prevContainers) => [...prevContainers, newContainer]);
  };

  const deleteContainer = (containerIndex) => {
    // Clone the containers array to avoid modifying the state directly
    const updatedContainers = [...containers];

    // Remove the container at the specified containerIndex
    updatedContainers.splice(containerIndex, 1);

    // Update the state with the modified containers array
    setContainers(updatedContainers);
  };
  const handleDropdownChange = (e, containerIndex, fieldsName) => {
    const updatedContainers = [...containers];
    // updatedContainers[containerIndex].processName = e.target.value;
    updatedContainers.map((item, index) => {
      if (index === containerIndex) {
        item[fieldsName] = e.target.value;
      }
    });
    // Update the state with the selected process name
    setContainers(updatedContainers);
  };

  const handleClick = (event, name) => {
    const newSelected = handleSelection(selected, name);
    setSelected(newSelected);
  };

  return (
    <Dashboard>
      <CustomBreadcrumb
        items={["Job", "Job/Create-job"]}
        onClick={handleClick}
      />
      <Box display={"flex"}>
        <ArrowBack />
        <h2>Create Job</h2>
      </Box>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="spanning table">
          <TableBody>
            <TableRow>
              <TableCell align="center">SO/Wo No</TableCell>
              <TableCell align="center">
                <TextField
                  label="So/Wo No"
                  id="outlined-size-small"
                  size="small"
                  variant="outlined"
                  name="soWo"
                  value={formData.soWo}
                  onChange={handleChange}
                  error={errors.soWo} // Set error prop based on the error state
                  helperText={errors.soWo ? "This field is required" : ""}
                />
              </TableCell>
              <TableCell align="center">Prod.Order No</TableCell>
              <TableCell align="center">
                <TextField
                  label="Prod.Order No"
                  id="outlined-size-small"
                  size="small"
                  name="prodOrderNo"
                  value={formData.prodOrderNo}
                  onChange={handleChange}
                  error={errors.prodOrderNo}
                  helperText={
                    errors.prodOrderNo ? "This field is required" : ""
                  }
                />
              </TableCell>
              {/* <TableCell align="center">WO Date</TableCell>
              <TableCell align="center">
                <TextField
                  id="date"
                  label="WO Date"
                  type="date"
                  size="small"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  //   value={selectedDate.toISOString().split("T")[0]}
                  //   onChange={(e) => handleDateChange(new Date(e.target.value))}
                  name="woDate"
                  value={formData.woDate}
                  onChange={handleChange}
                />
              </TableCell> */}
              <TableCell align="center">PO No</TableCell>
              <TableCell align="center">
                <TextField
                  label="PO No"
                  id="outlined-size-small"
                  size="small"
                  name="poNo"
                  value={formData.poNo}
                  onChange={handleChange}
                  error={errors.poNo}
                  helperText={errors.poNo ? "This field is required" : ""}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="center">Job Name</TableCell>
              <TableCell align="center">
                <TextField
                  label="Job Name"
                  id="outlined-size-small"
                  size="small"
                  name="jobName"
                  value={formData.jobName}
                  onChange={handleChange}
                  error={errors.jobName}
                  helperText={errors.jobName ? "This field is required" : ""}
                />
              </TableCell>
              <TableCell align="center">Drawing No</TableCell>
              <TableCell align="center">
                <TextField
                  label="Drawing No"
                  id="outlined-size-small"
                  size="small"
                  name="dragNo"
                  value={formData.dragNo}
                  onChange={handleChange}
                  error={errors.dragNo}
                  helperText={errors.dragNo ? "This field is required" : ""}
                />
              </TableCell>
              <TableCell align="center">Total Estimated CT</TableCell>
              <TableCell align="center">
                <TextField
                  label="Estimated CT"
                  id="outlined-size-small"
                  size="small"
                  name="estimatedtotalCT"
                  disabled
                  value={formatTotalEstimatedCT(formData.estimatedtotalCT)}
                  onChange={handleChange}
                  error={errors.estimatedtotalCT}
                  helperText={
                    errors.estimatedtotalCT ? "This field is required" : ""
                  }
                />
                {/* Optional: Show breakdown tooltip */}
                <Tooltip
                  title={`Process: ${totalCTBreakdown.processTime} | Setting: ${totalCTBreakdown.settingTime}`}
                >
                  <Typography variant="caption" display="block">
                    (Includes setting time)
                  </Typography>
                </Tooltip>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {containers.map((container, containerIndex) => (
        <TableContainer
          key={containerIndex}
          component={Paper}
          sx={{ marginTop: 3 }}
        >
          <TableRow sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <TableCell>{containerIndex + 1}</TableCell>
              <TableCell>
                <FormControl>
                  <InputLabel
                    id="demo-multiple-name-label"
                    style={{ color: "#1D5393" }}
                  >
                    MainProcessName
                  </InputLabel>
                  <Select
                    value={container.processName}
                    label="processName"
                    className="input"
                    size="small"
                    onChange={(e) =>
                      handleDropdownChange(e, containerIndex, "processName")
                    }
                  >
                    <MenuItem value="Milling">MILLING</MenuItem>
                    <MenuItem value="Boring">BORING</MenuItem>
                    <MenuItem value="Drilling">DRILLING</MenuItem>
                    <MenuItem value="Tapping">TAPPING</MenuItem>
                  </Select>
                </FormControl>
              </TableCell>
              <TableCell align="center">
                <Typography
                  variant="body2"
                  style={{
                    color: "#6B7280",
                    width: 200,
                    alignSelf: "flex-end",
                  }}
                >
                  Setting for All Process Admin have to add setting time in
                  minutes
                </Typography>
              </TableCell>
              <TableCell align="center">
                <TextField
                  label="settingTime"
                  className="input"
                  size="small"
                  name={`setting-${containerIndex}`}
                  value={container.setting}
                  onChange={(e) =>
                    handleDropdownChange(e, containerIndex, "setting")
                  }
                />
              </TableCell>
            </div>
            <Tooltip title="Delete Container" arrow placement="top">
              <IconButton size="small" sx={{ marginRight: 3 }}>
                <DeleteOutlineIcon
                  color="error"
                  onClick={() => deleteContainer(containerIndex)}
                />
              </IconButton>
            </Tooltip>
          </TableRow>
          {/* Add ProcessTable component with appropriate props */}
          <ProcessTable
            key={containerIndex}
            data={container.processTableData}
            handleTextFieldChange={handleTextFieldChange}
            handleDeleteRow={handleDeleteRow}
            processTableErrors={processTableErrors}
            containerIndex={containerIndex}
            handleAddRow={handleAddRow}
            selectedProcessName={container.processName}
            handleValidation={handleValidation}
            ToolSelect={ToolSelect}
            handleOpenToolModal={handleOpenToolModal} // Add this line
          />
        </TableContainer>
      ))}
      <Button
        onClick={addContainer}
        color="primary"
        sx={{
          backgroundColor: "#1d5393",
          color: "#fff",
          margin: 2,
          "&:hover": {
            backgroundColor: "#245BA1", // Adjust the color for hover effect
          },
          "&:active": {
            backgroundColor: "#1d5393", // Keep the same color as the initial state
          },
        }}
      >
        Add Main Process
      </Button>

      {/* Common Custom Tool Modal */}
      <CustomToolModal
        open={toolModalOpen}
        onClose={handleCloseToolModal}
        onSave={handleSaveCustomTool}
        title="Add Custom Tool"
        inputLabel="Tool Name"
        buttonText="Save Tool"
      />

      <MyModal
        open={isModalOpen} // Use 'open' instead of 'isOpen'
        onClose={handleCloseModal}
        title="Error Message" // Set the title you want to display
        description={modalMessage} // Use 'description' instead of 'message'
        buttonText="OK" // Set the button text you want to display
        onButtonClick={handleCloseModal} // Set the button click handler
      />
      <Button
        color="primary"
        sx={{
          backgroundColor: "#1d5393",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#245BA1", // Adjust the color for hover effect
          },
          "&:active": {
            backgroundColor: "#1d5393", // Keep the same color as the initial state
          },
        }}
        onClick={handleSubmit}
      >
        Save
      </Button>
      <MyModal
        open={isModalOpen}
        onClose={handleCloseModal}
        title="Message" // You can change this to "Success" or "Error" based on context
        description={modalMessage}
        buttonText="OK"
        onButtonClick={handleCloseModal}
      />
    </Dashboard>
  );
}

export default CreateJob;
